import React from "react";
import {EvacuadosPorSector as EvacuadosPorSectorContainer} from '../../../containers/EvacuadosPorSector'
import { CAMPAIGN_2023 } from '../../../constants';

const EvacuadosPorSector = () => {
  return <EvacuadosPorSectorContainer campaign={CAMPAIGN_2023} year={2023}/>
};

export default EvacuadosPorSector;
